import { render, staticRenderFns } from "./addTaskDialog.vue?vue&type=template&id=1bec9812&scoped=true&"
import script from "./addTaskDialog.vue?vue&type=script&lang=js&"
export * from "./addTaskDialog.vue?vue&type=script&lang=js&"
import style0 from "./addTaskDialog.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./addTaskDialog.vue?vue&type=style&index=1&id=1bec9812&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec9812",
  null
  
)

export default component.exports